import script from "./ProductConfigurableModulesOverlay.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductConfigurableModulesOverlay.vue?vue&type=script&lang=ts&setup=true"

import "./ProductConfigurableModulesOverlay.vue?vue&type=style&index=0&id=39128f17&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39128f17"]])

export default __exports__